<template>
  <!-- 教师获奖统计 -->
  <div class="box fl">
    <div class="line">
      <el-divider></el-divider>
    </div>
    <div class="tu">
      <div
        style="width:100%;height:100%"
        class="chart-class"
        ref="teachersAward"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    teacherAwardList:"",
  },
  data() {
    return {};
  },
  computed:{
    nameList(){
      return this.teacherAwardList.map(item=>item.honorType2Desc)
    },
    valueList(){
      return this.teacherAwardList.map(item=>item.honorNum)
    },
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      let data = {
        xData: this.nameList,
        yData: this.valueList,
      };

      let option = {
        title: {
          text: "教师获奖统计",
          x: "50%",
          y: "0%",
          textAlign: "center",
          textStyle: {
            fontSize: "24",
            fontWeight: "700",
            color: "#555",
            textAlign: "center",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        // 一个series 只能显示一个
        // legend: {
        //   x: "center",
        //   top: "17%",
        //   textStyle: {
        //     color: "rgba(0, 0, 0, 0.45)",
        //     fontSize: 13,
        //   },
        //   //原点
        //   icon: "circle",
        //   //修改icon图形大小
        //   itemHeight: 6,
        //   data: ["国家级", "市级", "区级", "校级"],
        // },

        grid: {
          top: "80",
          left: "3%",
          right: "4%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
            },
            data: data.xData,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              formatter: "{value}",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: "bar",
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#000000",
              },
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorListr = ["#FF7250", "#FFAA00", "#36CB8C", "#597EF7"];
                  return colorListr[params.dataIndex];
                },
                label: {
                  show: true,
                  position: "top",
                  formatter: "{c}个",
                  fontSize: 17,
                },
                shadowBlur: 10,
                shadowColor: "rgba(40, 40, 40, 0.3)",
              },
            },
            data: data.yData,
          },
        ],
      };

      let myChart = this.$echarts.init(this.$refs.teachersAward);
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  .line {
    position: relative;
    top: 0px;
    left: 0px;
    .el-divider--horizontal {
      position: absolute;
      top: 20px;
      left: 0px;
    }
  }
  box-sizing: border-box;
  width: 278px;
  height: 282px;
  margin-bottom: 24px;
  margin-right: 24px;
  background: #fff;
  border-radius: 7px;
  padding: 20px 24px;
  .tu {
    width: 100%;
    height: 100%;
  }
}
</style>
